export default __webpack_public_path__ + "static/2-70dd00607f856c742a71d262034cdfc3.png";